import templateUrl from './copy.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    copyAreas: '<',
    isTreat: '<',
    onCopied: '&'
  },
  controller: class CopyComponent {
    constructor(EventEmitter, ProductService) {
      'ngInject';

      Object.assign(this, { EventEmitter, ProductService });
    }

    searchProductsByNameForCopy(name, isTreat) {
      return this.ProductService.searchProductsByNameForCopy(name, isTreat).then(p => p.data);
    }

    onSubmit() {
      this.onCopied(
        this.EventEmitter({
          product: this.selectedProduct,
          copyAreas: this.selectedCopyAreas
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/copy/copy.component.js